/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RoofStructureEnum = 1 | 2 | 3 | 4;

export const RoofStructureEnum = {
    NUMBER_1: 1 as RoofStructureEnum,
    NUMBER_2: 2 as RoofStructureEnum,
    NUMBER_3: 3 as RoofStructureEnum,
    NUMBER_4: 4 as RoofStructureEnum
};

